import { render, staticRenderFns } from "./userChgCard.vue?vue&type=template&id=a1c2975c&scoped=true&"
import script from "./userChgCard.vue?vue&type=script&lang=js&"
export * from "./userChgCard.vue?vue&type=script&lang=js&"
import style0 from "./userChgCard.vue?vue&type=style&index=0&id=a1c2975c&lang=less&scoped=true&"
import style1 from "./userChgCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c2975c",
  null
  
)

export default component.exports